var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGradeA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.12109 13.6706L8.32087 12.8066",
    stroke: "url(#paint0_linear_1735_743)",
    strokeWidth: 0.979169,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18052 2.72776V2.77383H7.2266H7.685H7.73108V2.72776V1.85022H8.60862H8.65469V1.80414V1.34574V1.29966H8.60862H7.73108V0.423828V0.37775H7.685H7.2266H7.18052V0.423828V1.29966H6.30469H6.25861V1.34574V1.80414V1.85022H6.30469H7.18052V2.72776Z",
    fill: "#D00000",
    stroke: "#D00000",
    strokeWidth: 0.0921571
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18627 11.3682H0.832031L3.87493 2.72852H5.3489L8.39179 11.3682H7.03756L4.64701 4.29784H4.58095L2.18627 11.3682ZM2.41335 7.98491H6.80635V9.08175H2.41335V7.98491Z",
    fill: "url(#paint1_linear_1735_743)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1735_743",
    x1: 8.32087,
    y1: 13.2386,
    x2: 1.12109,
    y2: 13.2386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001C54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1735_743",
    x1: 8.39179,
    y1: 7.04838,
    x2: 0.832031,
    y2: 7.04838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001C54"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGradeA);
export default __webpack_public_path__ + "static/media/icon-gradeA.659d58795571c07415ff4a31bb674bb0.svg";
export { ForwardRef as ReactComponent };